// extracted by mini-css-extract-plugin
module.exports = {"module-wrapper":"ModuleWrapper_module-wrapper__hLK9s"};